
import { useNavigate } from "react-router-dom";
import ApplicationAppService from "../../../application/platform/application-app-service";
import { useBaseLayoutController } from "../../base-layout/context/base-layout-controller";
import { ACTION_TYPES, useBaseInternalFormDispatch, useBaseInternalFormState } from "./base-internal-form-context";
import { DefaultDialogProps } from "../../components/default-dialog";

export const useBaseInternalFormController = () => {
    const { showDialog } = useBaseLayoutController();
    const baseInternalFormDispatch = useBaseInternalFormDispatch();
    const baseInternalFormState = useBaseInternalFormState();
    const navigate = useNavigate();
    
    function toggleDrawer() {

        baseInternalFormDispatch({
            type: ACTION_TYPES.setDrawerOpen,
            payload: !baseInternalFormState.drawerOpen,
        });

    };
    function logout() {
        showDialog(
            {
                open: true,
                message: "Deseja realmente sair da aplicação?",
                onYesClick: () => {
                    ApplicationAppService.clearAuthenticationData();
                    navigate(`/`);
                }
            } as DefaultDialogProps
        );
    }
    return {
        toggleDrawer, logout
    };
}